import React, { useState } from 'react'
import { Lock, ArrowRight } from 'lucide-react'

const API_URL = '/api/nim'

interface LoginScreenProps {
  onLogin: (token: string) => void
  error?: string
}

const LoginScreen: React.FC<LoginScreenProps> = ({ onLogin, error }) => {
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [localError, setLocalError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setLocalError('')

    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      })

      if (!response.ok) {
        throw new Error('Invalid password')
      }

      const data = await response.json()
      onLogin(data.access_token)
    } catch (err) {
      setLocalError(err instanceof Error ? err.message : 'Login failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-icon">
          <Lock size={48} />
        </div>
        
        <h2>Enter Room</h2>
        <p className="login-subtitle">NIM Speech Translator</p>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Room password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onInput={(e) => setPassword(e.currentTarget.value)}
            disabled={loading}
            autoFocus
          />
          
          {(localError || error) && (
            <p className="error-text">{localError || error}</p>
          )}

          <button type="submit" disabled={loading || !password}>
            {loading ? (
              'Entering...'
            ) : (
              <>
                Enter Room
                <ArrowRight size={20} />
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  )
}

export default LoginScreen
